import "./TheScene.module.css";
import Header from "@/reusable_sections/Header";
import LiveTracking from "./sections/LiveTracking";
import CommunityVibes from "./sections/CommunityVibes";
import JoinTheScene from "./sections/JoinTheScene";
import Footer from "@/reusable_sections/Footer";
export default function TheScenePage() {
  return <div>
      <Header />
      <LiveTracking />
      <CommunityVibes />
      <JoinTheScene />
      <Footer />
    </div>;
}